import React from 'react';
import DeleteObject from '../../../common/poppers/DeleteObject';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ActivateObject from '../../../common/poppers/ActivateObject';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import ModifyCarDay from './ModifyCarDay';
import NewRefuel from './NewRefuel';
import AddIcon from '@material-ui/icons/Add';
import ModifyRefuel from './ModifyRefuel';
import LocalGasStation from '@material-ui/icons/LocalGasStation';
import DeleteRefuel from './DeleteRefuel';


export const carDayActionItems = [

    {
        dataDialog: "modify-dialog",
        title: "Nap módosítása",
        dialogTitle: "Nap módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        canShow: (row) => row,
        actionComponent: (props, close) => <ModifyCarDay {...props} close={close} />
    },
    {
        mainMenu: "Tankolás",
        icon: <LocalGasStation fontSize="small" color="primary" />,
        subMenus: [
            {
                dataDialog: "refuel-dialog",
                title: "Tankolás hozzáadása",
                dialogTitle: "Tankolás hozzáadása",
                icon: <AddIcon fontSize="small" color="primary" />,
                canShow: (row) => row,
                actionComponent: (props, close) => <NewRefuel {...props} close={close} />
            },
            {
                dataDialog: "modify-refuel-dialog",
                title: "Tankolás módosítása",
                dialogTitle: "Tankolás módosítása",
                icon: <EditIcon fontSize="small" color="primary" />,
                canShow: (row) => row.refuels,
                actionComponent: (props, close) => <ModifyRefuel {...props} close={close} />
            },
            {
                dataDialog: "delete-refuel-dialog",
                title: "Tankolás törlése",
                dialogTitle: "Tankolás törlése",
                icon: <DeleteIcon fontSize="small" color="primary" />,
                canShow: (row) => row.refuels,
                actionComponent: (props, close) => <DeleteRefuel {...props} close={close} />
            },
        ]
    },
    {
        divider: true,
    },
    {
        dataDialog: "delete-dialog",
        title: "Nap törlése",
        dialogTitle: "Nap törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/carday'} confirm={"Biztos hogy törölni szeretnéd az egész napot?"} comp={<div>{props.row.licenseNumber} {props.row.date} </div>} />
    },
]